// import * as types from '@store/mutation-types'

// initial state
// shape: [{ id, quantity }]
const state = {}

// getters
const getters = {
  // user: state => state.user
}

// actions
const actions = {
  getUserTagTable ({commit}, params) {
    let promised = request.alert('getUserTagTable', params)
    return promised
  },
}

// mutations
const mutations = {}

export const userTag = {
  state,
  getters,
  actions,
  mutations,
}



// WEBPACK FOOTER //
// ./src/views/user-tag/userTag.store.js